import * as React from 'react';
import { FormField, renderIcon } from '@ixicare/ui';
import { Field } from '../schema';
import styles from '../styles.module.css';
import { t } from '~i18n';
import connect from '~store/connect';
import DeviceStore from '~modules/devices/store/Device';
import { State } from '~store/types';
import { RefreshCcw } from 'lucide-react';

interface Props {
  field: Field;
  label: React.ReactNode;
  deviceStore?: DeviceStore;
}

const StatusBlockControl: React.FC<Props> = ({ field, label, deviceStore }) => {
  const job = deviceStore!.otaJob;
  const status =
    job && typeof job.status === 'string'
      ? t(`device-config.ota-job.status.${job.status.toLowerCase()}`)
      : t('device-config.ota-job.none');

  return (
    <div className={styles.statusField}>
      {field.action && (
        <button
          type="button"
          className={styles.ActionButton}
          onClick={deviceStore!.getConfigStatus}
          disabled={deviceStore?.loading}
          aria-label={t('genericTable.refreshAria')}
          title={t('genericTable.refreshAria')}
        >
          {renderIcon('refresh', RefreshCcw)}
        </button>
      )}
      <FormField label={label}>
        <div className={styles.statusBox}>{status}</div>
      </FormField>
    </div>
  );
};

export default connect((state: State) => ({
  deviceStore: state.device,
}))(StatusBlockControl);
